// Shared domain constants derived from SPEC.md.

// Overridable per environment via .env files (VUE_APP_API_BASE_URL).
// Falls back to the local XAMPP backend for development.
export const API_BASE_URL =
  process.env.VUE_APP_API_BASE_URL || 'http://localhost/3h_villas/'

// localStorage keys for the persisted session.
export const STORAGE_KEYS = Object.freeze({
  TOKEN: 'hms_token',
  USER: 'hms_user',
  PERMISSIONS: 'hms_permissions'
})

// RBAC — section 3. Permissions are assigned individually; no fixed roles.
export const PERMISSION_LEVELS = Object.freeze({
  VIEW: 'view',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  APPROVE: 'approve',
  VOID: 'void',
  EXPORT: 'export',
  PRINT: 'print',
  AUDIT: 'audit'
})

export const DATA_SCOPES = Object.freeze({
  OWN: 'own',
  DEPARTMENT: 'department',
  HOTEL: 'hotel'
})

// Room statuses — section 7.
export const ROOM_STATUS = Object.freeze({
  AVAILABLE: 'available',
  RESERVED: 'reserved',
  OCCUPIED: 'occupied',
  CLEANING: 'cleaning',
  MAINTENANCE: 'maintenance',
  BLOCKED: 'blocked'
})

// Housekeeping statuses — section 16.
export const HOUSEKEEPING_STATUS = Object.freeze({
  DIRTY: 'dirty',
  CLEANING: 'cleaning',
  CLEAN: 'clean',
  INSPECTED: 'inspected',
  MAINTENANCE: 'maintenance'
})

// Reservation statuses — section 9.
export const RESERVATION_STATUS = Object.freeze({
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  CHECKED_IN: 'checked_in',
  CHECKED_OUT: 'checked_out',
  CANCELLED: 'cancelled',
  NO_SHOW: 'no_show',
  TIMED_OUT: 'timed_out'
})

// Order statuses — sections 12/13.
export const ORDER_STATUS = Object.freeze({
  PENDING: 'pending',
  PREPARING: 'preparing',
  SERVED: 'served',
  CANCELLED: 'cancelled'
})

// Outlet order types — sections 12/13/14.
export const ORDER_TYPES = Object.freeze({
  RESTAURANT: 'restaurant',
  BAR: 'bar',
  ROOM_SERVICE: 'room_service'
})

// Laundry workflow — section 15.
export const LAUNDRY_STATUS = Object.freeze({
  REQUESTED: 'requested',
  PICKED_UP: 'picked_up',
  PROCESSING: 'processing',
  DELIVERED: 'delivered'
})

// Inventory — section 18.
export const INVENTORY_CATEGORIES = Object.freeze({
  FOOD: 'food',
  BEVERAGE: 'beverage',
  HOUSEKEEPING: 'housekeeping',
  AMENITY: 'amenity'
})

export const STOCK_MOVEMENTS = Object.freeze({
  IN: 'in',
  OUT: 'out',
  TRANSFER: 'transfer',
  ADJUSTMENT: 'adjustment'
})

// Payment methods — section 22.
export const PAYMENT_METHODS = Object.freeze({
  PAYSTACK: 'paystack',
  CASH: 'cash',
  POS: 'pos',
  BANK_TRANSFER: 'bank_transfer'
})
